import { Pass, ShowText, Title, Cond, Option, Seq, Par, Choice, Select, Cont, Dep, PLock, PLabel } from "../framework/Processes";
import { setObjectValue, getObjectValue } from "../framework/Lang";

import "./minigames";
import MinigamesConfig from './MinigamesConfig';

import RunMinigameProcess from "./minigameProcess/RunMinigameProcess";

import "./TypeDefinition";

var ActualGameProcess = PLock("main", Seq([
	Pass,
	setObjectValue("history", []),
	/* setObjectValue("advise", []),
	setObjectValue("subtask", []), */
	setObjectValue("menu", MinigamesConfig.allMinigameNames.map(name => MinigamesConfig.getMinigameByName(name)).map(({ name, title }) => ({ name, title }))),
	//selectDifficultyProcess,
	PLabel("main", RunMinigameProcess(MinigamesConfig)),
]));

export default ActualGameProcess;
